import React, { useEffect, useState } from "react";
import logo from "../../images/managekaro logo.png";
import inventory from "../../images/inventory-main.png";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import ClipLoader from "react-spinners/ClipLoader";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Redirect, useHistory } from "react-router-dom";

import UserRepository from "../../Repository/UserRepository";

import { Grid, styled, Typography, TextField } from "@mui/material";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { BtnLogin, BtnSelect } from "./style";
import ReactCountryFlag from "react-country-flag";
import { countries } from "./CountriesList";
import { useDispatch } from "react-redux";
import { getTrial, userPaid } from "../trial/trialSlice";
import TrialDialog from "../trial/TrialDialog";
import { Toast } from "../../components/components/Toast";
import { loadGoogleAnalytics } from "../analytics/analytics";
import { getUser } from "../userSlice";

const RightSection = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#ffffff",
  height: "100vh",
});
const LeftSection = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "space-evenly",
  justifyContent: "space-evenly",
  height: "100vh",
});
const Input = styled(TextField)({
  background: "#ffffff",
  borderRadius: "12px",
});

const schema = yup
  .object()
  .shape({
    name: yup.string().required("Required"),
    password: yup.string().required("Required"),
  })
  .required();

function Login() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [verificationError, setVerificationError] = useState("");
  const [isLeft, setIsLeft] = useState(false);
  const [loginType, setLoginType] = useState("admin");
  console.log("loginType", loginType);
  const [showPassword, setShowPassword] = React.useState(false);
  const [isPhone, setIsPhone] = useState(true);
  const history = useHistory();
  const [selectedCountry, setSelectedCountry] = useState("+92");
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [isTrialEnded, setIsTrialEnded] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const trackingId = "G-9JX2HR95FS";

  // const navigate=useNavigate()

  const {
    reset,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams) {
      setValue("name", urlParams.get("email"));
      setValue("password", urlParams.get("password"));
    }
  }, []);
  console.log("l", localStorage.getItem("tokenType"));
  const token = localStorage.getItem("tokenType");

  if (token === "admin") {
    console.log("localad", localStorage.getItem("tokenType"));
    return <Redirect to="/inventory/admin" />;
  }

  const toggle = () => {
    setIsPhone((prev) => !prev);
  };

  const userLogin = async (arg, loginTypeLabel) => {
    reset();
    setLoading(true);
    // localStorage.clear();
    const { data } = await UserRepository.usersModel({
      request: {
        method: "getUser",
        data: {
          _id: arg.password,
        },
      },
    });
    let user = data.response.data.user;
    console.log("log", user);
    if (data.response.status.statusCode == 200) {
      // loadGoogleAnalytics(trackingId)
      // if (typeof gtag !== "undefined") {
      //   gtag("event", "login_success", {
      //     event_category: "Authentication",
      //     event_label: loginTypeLabel,
      //     value: 1,
      //   });
      // }
      localStorage.setItem("username", user.username);
      localStorage.setItem("token", user.username);
      localStorage.setItem("tokenType", "user");
      localStorage.setItem("company", user.company_name);
      localStorage.setItem("companyCode", user.company_code);
      localStorage.setItem("income", user.income);
      localStorage.setItem("further", user.further);
      localStorage.setItem("address", user.address.city);
      localStorage.setItem("street", user.address.street);
      //  localStorage.setItem("ledgerRegions", user.ledgerRegions);
      localStorage.setItem("ledgerRegions", JSON.stringify(user.ledgerRegions));

      if (user.address != null) {
        localStorage.setItem("terms", user.address.terms);
      }
      if (user.base_url != null) {
        localStorage.setItem("base_url", user.base_url);
      }

      if (user?.address?.selectedPhone == "phoneTwo") {
        localStorage.setItem("phone", user.address.phoneTwo);
      } else if (user?.address?.selectedPhone == "phoneOne") {
        localStorage.setItem("phone", user.address.phoneOne);
      } else if (user?.address?.selectedPhone == "bothNumbers") {
        localStorage.setItem("p1", user?.address?.phoneOne);
        localStorage.setItem("p2", user?.address?.phoneTwo);
      } else {
        localStorage.setItem("phone", user.phone || "");
      }

      localStorage.setItem("companyId", user._id);
      console.log("token", localStorage.getItem("tokenType"));
      dispatch(userPaid());
      setLoading(false);
      if (localStorage.getItem("tokenType") === "user") {
        console.log("check", localStorage.getItem("tokenType"));
        // return <Redirect to="/inventory/dashboard" />;
        return history.push("/inventory/dashboard");
      }

      setVerificationError("");
    } else {
      setVerificationError("Invalid Credential");
      setLoading(false);
    }
  };

  const adminLogin = async (data, loginTypeLabel) => {
    try {
      reset();
      setLoading(true);

      // let obj = {
      //   password: data.password,
      // };

      // if (isPhone) {
      //   obj.phone = `${selectedCountry}${data.name}`;
      // } else {
      //   obj.email = data.name;
      // }

      const res = await UserRepository.usersModel({
        request: {
          method: "loginAdmin",
          data: {
            user: {
              password: data.password,
              email: data.name,
            },
          },
        },
      });

      if (res.data.response.status.statusCode == 200) {
        // loadGoogleAnalytics(trackingId);

        // if (typeof gtag !== "undefined") {
        //   gtag("event", "login_success", {
        //     event_category: "Authentication",
        //     event_label: loginTypeLabel,
        //     value: 1,
        //   });
        // }
        let User = res.data.response.data.user;
        if (User) {
          if (User.isPaid || User.isTrial) {
            Toast("success", "Login Successfully");
          }

          if (User.gst) {
            localStorage.setItem("gst", User.gst);
          }
          console.log(User);

          localStorage.removeItem("address");
          localStorage.setItem("username", User.name);
          localStorage.setItem("token", User.email);
          localStorage.setItem("tokenType", "admin");
          localStorage.setItem("company", User.company_name);
          localStorage.setItem("companyCode", User.company_code);

          if (User?.address?.selectedPhone == "phoneTwo") {
            localStorage.setItem("phone", User.address.phoneTwo);
          } else if (User?.address?.selectedPhone == "phoneOne") {
            localStorage.setItem("phone", User.address.phoneOne);
          } else if (User?.address?.selectedPhone == "bothNumbers") {
            localStorage.setItem("p1", User?.address?.phoneOne);
            localStorage.setItem("p2", User?.address?.phoneTwo);
          } else {
            localStorage.setItem("phone", User.phone || "");
          }
          localStorage.setItem("email", User.email);
          let onlystringaddress = typeof User.address == "string";
          if (onlystringaddress == true) {
            localStorage.setItem("address", User.address);
          } else {
            localStorage.setItem(
              "address",
              User.address.street + " " + User.address.city
            );
          }
          if (User.address != null) {
            localStorage.setItem("terms", User.address.terms);
          }
          if (User.base_url != null) {
            localStorage.setItem("base_url", User.base_url);
          }
          console.log("logAdmin", User);

          setLoading(false);

          if (User.isPaid) {
            dispatch(userPaid());
          } else {
            dispatch(getTrial());
          }

          const compRes = await UserRepository.companiesModel({
            request: {
              method: "getCompany",
              data: {
                _id: User.company_code,
              },
            },
          });

          localStorage.setItem(
            "gstType",
            compRes.data?.response.data?.company[0]?.gstType
          );
          if (compRes.data?.response.data?.company[0]?.income) {
            localStorage.setItem(
              "income",
              compRes.data?.response.data?.company[0]?.income
            );
          }
          if (compRes.data?.response.data?.company[0]?.further) {
            localStorage.setItem(
              "further",
              compRes.data?.response.data?.company[0]?.further
            );
          }

          if (
            compRes.data?.response.data?.company.length > 0 &&
            compRes.data?.response.data?.company[0].access != null
          ) {
          }
        } else {
          setLoading(false);
          setVerificationError(
            res.data.response.status.statusDescription ||
              res.data.response.status.statusMessage
          );
        }
        dispatch(getUser());
      } else {
        setLoading(false);
        setVerificationError(
          res.data.response.status.statusDescription ||
            res.data.response.status.statusMessage
        );
        console.log("res.data.response.data.error", res.data.response.data.error);
        let msg =
          "Your account has been deactivated due to an outstanding payment. Please contact our representative on 0331-5921209 for reactivation.";
        if (res.data.response.data.error == msg) {
          handleTrialDialog();
        }
      }
    } catch (err) {
      console.log("err:", err);
      Toast("error", err.message);
      setLoading(false);
    }
  };

  // const submitForm = () => {
  //   loginType == "admin"
  //     ? handleSubmit(adminLogin)()
  //     : handleSubmit(userLogin)();
  // };

  const submitForm = () => {
    const loginTypeLabel = loginType === "admin" ? "Admin Login" : "User Login";

    // Send a "login_attempt" event

    // Call respective login functions
    loginType === "admin"
      ? handleSubmit((data) => adminLogin(data, loginTypeLabel))()
      : handleSubmit((data) => userLogin(data, loginTypeLabel))();
  };

  const handleTrialDialog = () => {
    setIsTrialEnded((prev) => !prev);
  };

  const handleClickOpen = () => {
    // setOpen(true);
    history.push("/inventory/signup");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNext = () => {
    setOpen(false);

    history.push("/inventory/signup");
  };
  const handleCountryChange = (e) => {
    const { value } = e.target;
    setSelectedCountry(value);
  };
  return (
    <>
      <Grid container>
        <Grid item md={6} xs={12}>
          <LeftSection>
            <Box align="center">
              <Typography variant="h6" sx={{ mt: 2, color: "#4daf51" }}>
                Welcome Back!
              </Typography>
              <Typography sx={{ mt: 2, color: "#999999" }}>
                Please Login To Continue.
              </Typography>
            </Box>
            <Box align="center" sx={{ mt: 2.5 }}>
              <BtnSelect
                sx={{
                  borderRadius: "4px 0px 0px 4px",
                  background: isLeft
                    ? "#4EAF51 !important"
                    : "#999999 !important",
                }}
                onClick={() => {
                  setIsLeft(true);
                  setVerificationError("");
                  setLoginType("user");
                  reset();
                  setLoading(false);
                }}
              >
                Employee Login
              </BtnSelect>
              <BtnSelect
                onClick={() => {
                  setIsLeft(false);
                  setVerificationError("");
                  setLoginType("admin");
                  setLoading(false);
                  reset();
                }}
                sx={{
                  background: !isLeft
                    ? "#4EAF51 !important"
                    : "#999999 !important",
                }}
              >
                Admin Login
              </BtnSelect>
            </Box>

            <Box align="center" sx={{ px: { xs: "5%", md: "10%" } }}>
              <h3 style={{ color: "red", fontWeight: "normal" }}>
                {verificationError}
              </h3>
              {/* {isPhone && (
                <div style={{ position: "relative" }}>
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 1,
                      marginLeft: "5px",
                    }}
                  >
                    <FormControl fullWidth sx={{ width: "fit-content" }}>
                      <Select
                        variant="outlined"
                        onChange={handleCountryChange}
                        defaultValue="+92"
                        sx={{
                          "& fieldset": { border: "none" },
                        }}
                      >
                        {countries.map((item, i) => {
                          return (
                            <MenuItem key={i} value={item.mobile}>
                              <Stack direction="row" alignItems="center">
                                <ReactCountryFlag countryCode={item.code} svg />
                                <Typography sx={{ ml: 1 }}>
                                  {item.mobile}
                                </Typography>
                              </Stack>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "100%" }}>
                    <OutlinedInput
                      sx={{
                        maxWidth: "100%",
                        background: "#ffffff",
                        pl: "120px",
                      }}
                      fullWidth
                      type="text"
                      variant="outlined"
                      label={loginType === "admin" ? "Mobile Number" : "Name"}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          submitForm();
                        }
                      }}
                      {...register("name")}
                    />
                  </div>
                  <Typography
                    sx={{
                      textAlign: "left",
                      fontSize: "14px",
                      color: "#4eaf51",
                      textDecoration: "underline",
                      ml: 1,
                    }}
                    onClick={toggle}
                  >
                    Login with email
                  </Typography>
                </div>
              )} */}
              {/* {!isPhone && (
                <div>
                  <Input
                    placeholder={loginType === "admin" ? "Email" : "Name"}
                    type="text"
                    fullWidth
                    variant="outlined"
                    onKeyDown={(e) => {
                      if (e.key == "Enter") {
                        submitForm();
                      }
                    }}
                    {...register("name")}
                  />
                  <Typography
                    sx={{
                      textAlign: "left",
                      fontSize: "14px",
                      color: "#4eaf51",
                      textDecoration: "underline",
                      ml: 1,
                    }}
                    onClick={toggle}
                  >
                    Login with phone
                  </Typography>
                </div>
              )} */}
              <Input
                label={
                  loginType === "admin" ? "Email or Mobile Number" : "Name"
                }
                type="text"
                fullWidth
                variant="outlined"
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    submitForm();
                  }
                }}
                {...register("name")}
              />

              {errors.name?.message && (
                <Typography sx={{ color: "red" }}>Required</Typography>
              )}

              <Input
                id="outlined-adornment-password"
                label={loginType === "admin" ? "Password" : "ID"}
                type={showPassword ? "text" : "password"}
                sx={{ mt: "3%" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                fullWidth
                variant="outlined"
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    submitForm();
                  }
                }}
                {...register("password")}
              />
              {errors.password?.message && (
                <Typography sx={{ color: "red" }}>Required</Typography>
              )}
            </Box>
            <Box align="center">
              {loading == false && (
                <BtnLogin onClick={submitForm} variant="contained" size="large">
                  LOG IN
                </BtnLogin>
              )}
              {loading == true && (
                <ClipLoader size={50} color={"#4DAF51"} loading={loading} />
              )}

              <h3
                onClick={handleClickOpen}
                style={{ cursor: "pointer", color: "#4EAF50" }}
              >
                Create An Account
              </h3>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <h5
                  style={{
                    color: "#999999",
                    margin: "0px",
                    padding: "0px",
                    mr: "5px !important",
                  }}
                >
                  Forgot password?
                </h5>
                <Link to="/reset-password">
                  <h5
                    style={{ color: "#4EAF50", margin: "0px", padding: "0px" }}
                  >
                    Reset
                  </h5>
                </Link>
              </Box>
            </Box>
          </LeftSection>
        </Grid>
        {!matches && (
          <Grid sx={{ height: "100vh", background: "#ffffff" }} item md={6}>
            <RightSection>
              <img
                style={{
                  marginBottom: "20px",
                  maxHeight: "20%",
                  maxWidth: "20%",
                }}
                src={logo}
                alt="logo"
              />
              <Typography variant="h6" sx={{ color: "#4daf51" }}>
                The Best Solution For All Your Business Needs
              </Typography>
              <img
                style={{ maxHeight: "55%", maxWidth: "55%" }}
                src={inventory}
                alt="logo"
              />
            </RightSection>
          </Grid>
        )}
      </Grid>

      {isTrialEnded && <TrialDialog onClose={handleTrialDialog} />}
    </>
  );
}

export default Login;
